
  Vue.component('widget-field', {
    props: {
      control: { type: Object },
      item: { type: Object },
      controlindex: { type: Number },
      persistedValues: { type: Object },
      currentusercv: { type: String, default: '' },
      currentusercvlastupload: { type: String, default: '' },
      isTrainingAgency: { type: Boolean, default: false },
      seekerId: { type: Number, default: -1 }
    },
    data() {
      return {
        showWhen: true,
        value: this.control.RetrievedValue,
        values: this.control.RetrievedValues,
        currentyear: new Date().getFullYear()
      }
    },
    template: '#widget-field',
    computed: {
      required() {
        return true
      }
    },
    watch: {},
    methods: {
      handleVisibility() {
        let retVal = true
        if (this.control.ShowWhen && this.control.ShowWhen.length > 0) {
          this.control.ShowWhen.forEach(sw => {
            retVal =
              retVal &&
              this.persistedValues[sw.Key] &&
              sw.Value.split(',').reduce(
                (acc, value) =>
                  acc ||
                  this.persistedValues[sw.Key].value === value ||
                  (this.persistedValues[sw.Key].values && this.persistedValues[sw.Key].values.indexOf(value) !== -1),
                false
              )
          })
        }
        this.showWhen = retVal
      },
      emitInterface() {
        const self = this
        this.$emit('interface', {
          key: self.control.Id,
          validate: () => self.validate(),
          containerRef: self.$refs.container
        })
      },
      handleFieldChange(e, control, value) {
        const id = control.Id.replace('q_Curriculum_', '')
        const fieldValue = value || e.target.value

        if (control.FieldType === 'multiselection') {
          const index = this.values.indexOf(fieldValue)
          if (index === -1) {
            this.values.push(fieldValue)
          } else {
            this.values.splice(index, 1)
          }
          this.$emit('change', { key: id, values: this.values })
        } else {
          this.value = fieldValue
          this.$emit('change', { key: id, value: fieldValue })
        }
      },
      RetrievedValueContains(wc, value) {
        if (wc.HasRetrievedValue) {
          if (wc.RetrievedValue != '') return wc.RetrievedValue == value
          if (wc.RetrievedValues !== null) {
            return wc.RetrievedValues.indexOf(value) > -1
          }
        }

        return false
      },
      ListRetrievedValuesContains(wc, value) {
        if (wc.HasRetrievedValue) {
          if (wc.RetrievedValues !== null) {
            return wc.RetrievedValues.indexOf(value) > -1
          }
        }

        return false
      },

      ListRetrievedValuesIsEqualAtIndex(wc, value, index) {
        if (wc.HasRetrievedValue) {
          if (wc.RetrievedValues !== null) {
            if (wc.RetrievedValues.length >= index + 1) {
              if (wc.RetrievedValues[index].length > -1) {
                return wc.RetrievedValues[index] == value
              }
            }
          }
        }

        return false
      },

      ListRetrievedValuesContainsAtIndex(wc, value, index) {
        if (wc.HasRetrievedValue) {
          if (wc.RetrievedValues !== null) {
            if (wc.RetrievedValues.length >= index + 1) {
              if (wc.RetrievedValues[index].length > -1) {
                return wc.RetrievedValues[index].indexOf(`;${value};`) > -1
              }
            }
          }
        }

        return false
      },

      GetCurrentDayFromNumber(number) {
        let day = ''

        switch (number) {
          case 1:
            day = 'Lunedì'
            break
          case 2:
            day = 'Martedì'
            break
          case 3:
            day = 'Mercoledì'
            break
          case 4:
            day = 'Giovedì'
            break
          case 5:
            day = 'Venerdì'
            break
          case 6:
            day = 'Sabato'
            break
          case 7:
            day = 'Domenica'
            break
          default:
            day = ''
        }

        return day
      },
      GetDisabilityCategories() {
        return {
          0: 'Categoria disabilità',
          9999: 'Altre categorie'
        }
      },

      GetProtectedCategoryWhoCanUse() {
        return {
          1: 'Azienda',
          2: 'Centro di formazione',
          3: 'Agenzia per il lavoro',
          4: 'Associazione di volontariato',
          5: 'Università',
          6: 'Scuola'
        }
      }
    },
    mounted() {
      this.emitInterface()
      this.handleVisibility()
      EventBus.$on('widgetChangeField', this.handleVisibility)
    },
    beforeDestroy() {
      EventBus.$off('widgetChangeField', this.handleVisibility)
    }
  })
